import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: 'input[trim]',
    standalone: true,
})
export class TrimDirective {

    private el = inject(ElementRef);
    private ngControl = inject(NgControl, { optional: true, self: true });

    constructor() { }

    @HostListener('blur')
    onBlur() {
        const input = this.el.nativeElement;
        const trimmedValue = input.value.trim();

        // Update view value
        input.value = trimmedValue;

        // Update form control value if it exists
        if (this.ngControl?.control) {
            this.ngControl.control.setValue(trimmedValue, {
                emitEvent: false,
                emitModelToViewChange: false
            });
        }
    }

}